import Swiper from 'swiper/swiper-bundle';
import screencheck from "./screencheck";

// Credentials Slider
if($('.credentials-slider').length) {
	if(screencheck(767)) {
		$('.credentials-slider').each(function(index, element){
			var $this = $(this);
			$this.find(".swiper-button-prev").addClass("credentials-prev-" + index);
			$this.find(".swiper-button-next").addClass("credentials-next-" + index);
			var credentialsSlider = new Swiper($(this)[0], {
				// lazy: true,
				grabCursor: true,
				noSwipingClass: 'play-audio',
				spaceBetween: 24,
				navigation: {
					nextEl: '.credentials-next-' + index,
					prevEl: '.credentials-prev-' + index,
				},
				pagination: {
					el: '.swiper-pagination',
					type: "fraction",
				},
				
			});
		});
	} else {
		$('.credentials-slider').each(function(index, element){
			var $this = $(this);
			$this.find(".swiper-button-prev").addClass("credentials-prev-" + index);
			$this.find(".swiper-button-next").addClass("credentials-next-" + index);
			var credentialsSlider = new Swiper($(this)[0], {
				// lazy: true,
				grabCursor: true,
				noSwipingClass: 'play-audio',
				navigation: {
					nextEl: '.credentials-next-' + index,
					prevEl: '.credentials-prev-' + index,
				},
				pagination: {
					el: '.swiper-pagination',
					type: "fraction",
				},
				effect: "creative",
				creativeEffect: {
					prev: {
						shadow: true,
						scale: 1.2,
						origin: `right center`,
						opacity: 0,
						translate: ["-27%", 0, 100],
					},
					next: {
						translate: ["27%", 0, -400],
						origin: `right center`,
						//scale: 0.75,
						opacity: 0.2,
					},
				},
				
			});
		});
	}	
}

// Counselor Slider
if($('.counselor-slider').length) {
	$('.counselor-slider').each(function(index, element){
		var $this = $(this);
		$this.find(".swiper-button-prev").addClass("counselor-prev-" + index);
    	$this.find(".swiper-button-next").addClass("counselor-next-" + index);
		var counselorSlider = new Swiper($(this)[0], {
			// resistanceRatio: 0,
			// shortSwipeThreshold: 30,
			// shortSwipes: false,
			threshold: 5,
			a11y: false, 
			watchSlidesProgress: true,
			lazy: {
				loadPrevNext: true,
				// loadPrevNextAmount: 4,
	
			},
			slidesPerView: 1,
			spaceBetween: 24,
			shortSwipes: false,
			navigation: {
				nextEl: '.counselor-next-' + index,
				prevEl: '.counselor-prev-' + index,
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 40,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
			},
		});
	})
}

// Team Slider
if($('.team-slider').length) {
	var teamSliderItem = $('.team-slider .swiper-slide').length;

	function teamSlider() {
		$('.team-row').removeClass('no-slider');
		$('.team-slider').each(function(index, element){
			var $this = $(this);
			$this.find(".swiper-button-prev").addClass("team-slider-prev-" + index);
			$this.find(".swiper-button-next").addClass("team-slider-next-" + index);
			var teamSwiper = new Swiper($(this)[0], {
				lazy: true,
				slidesPerView: 'auto',
				// slidesPerView: 1,
				spaceBetween: 24,
				navigation: {
					nextEl: '.team-slider-next-' + index,
					prevEl: '.team-slider-prev-' + index,
				},
				breakpoints: {
					576: {
						// slidesPerView: 2,
						// slidesPerView: 'auto',
						slidesPerView: 2,
						spaceBetween: 40,
					},
					992: {
						slidesPerView: 3,
						// slidesPerView: itemNumber,
						// spaceBetween: 32,
						spaceBetween: 40,
					},
					1200: {
						slidesPerView: 4,
						// slidesPerView: itemNumber,
						spaceBetween: 40,
					},
				},
			});
		})
		// var teamSwiper = new Swiper('.team-slider', {
		// 	lazy: true,
		// 	slidesPerView: 'auto',
		// 	// slidesPerView: 1,
		// 	spaceBetween: 24,
		// 	navigation: {
		// 		nextEl: '.swiper-button-next',
		// 		prevEl: '.swiper-button-prev',
		// 	},
		// 	breakpoints: {
		// 		576: {
		// 			// slidesPerView: 2,
		// 			// slidesPerView: 'auto',
		// 			slidesPerView: 2,
		// 			spaceBetween: 40,
		// 		},
		// 		992: {
		// 			slidesPerView: 3,
		// 			// slidesPerView: itemNumber,
		// 			// spaceBetween: 32,
		// 			spaceBetween: 40,
		// 		},
		// 		1200: {
		// 			slidesPerView: 4,
		// 			// slidesPerView: itemNumber,
		// 			spaceBetween: 40,
		// 		},
		// 	},
		// });
	}

	// console.log(teamSlider(4));

	
	
	// $(window).on('resize', function(){
	// 	var hell = screencheck(1200) ? 4 : 5;
	// 	if(teamSliderItem == hell) {
	// 		console.log('3');
	// 		teamSlider(3)
	// 	} else {
	// 		console.log('4');
	// 		console.log(teamSliderItem);
	// 		console.log(teamSlider(4));
	// 		if(teamSliderItem > 4) {
	// 			console.log('abxc');
	// 		}
	// 		teamSlider(4)
	// 	}
	// }).resize();


	
	if(teamSliderItem > 4) {
		$('.team-row').addClass('five');
		teamSlider()
		// teamSlider();
	} else if(teamSliderItem < 5 && teamSliderItem > 3) {
		$('.team-row').addClass('no-slider four');
		if(screencheck(1200)) {
			teamSlider()
		}
	} else if(teamSliderItem < 4 && teamSliderItem > 2) {
		$('.team-row').addClass('no-slider three');
		if(screencheck(991)) {
			teamSlider()
		}
	} else if(teamSliderItem < 3 && teamSliderItem > 1) {
		$('.team-row').addClass('no-slider two');
		if(screencheck(575)) {
			teamSlider()
		}
	// } else if(teamSliderItem < 2 && teamSliderItem > 0) {
	} else {
		$('.team-row').addClass('no-slider one');
	}

	if($('.team-row').hasClass('no-slider')) {
		$('.team-row .team-box img').each(function () {
			var $this = $(this),
				$thisSrc = $this.data('src');
			$this.next('.swiper-lazy-preloader').remove();
			console.log($thisSrc);
			$this.removeAttr('data-src');
			$this.attr('src', $thisSrc);
		})
	}
	
}


// Timeline slider

if($('.timeline-year-slider').length) {
	var timelineYearSlider = new Swiper(".timeline-year-slider", {
		// lazy: true,
		loop: false,
		spaceBetween: 24,
		slidesPerView: 'auto',
		freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			992: {
				spaceBetween: 48,
			},
		},
	});

	$('.timeline-info-slider').each(function(index, element){
		var $this = $(this);
		$this.find(".swiper-button-prev").addClass("timeline-info-prev-" + index);
		$this.find(".swiper-button-next").addClass("timeline-info-next-" + index);
		var timelineInfoSlider = new Swiper($(this)[0], {
			// lazy: true,
			loop: false,
			spaceBetween: 10,
			navigation: {
				nextEl: '.timeline-info-next-' + index,
				prevEl: '.timeline-info-prev-' + index,
			},
			thumbs: {
				swiper: timelineYearSlider,
			},
		});
	})
	// var timelineInfoSlider = new Swiper(".timeline-info-slider", {
	// 	lazy: true,
	// 	loop: false,
	// 	spaceBetween: 10,
	// 	navigation: {
	// 		nextEl: ".swiper-button-next",
	// 		prevEl: ".swiper-button-prev",
	// 	},
	// 	thumbs: {
	// 		swiper: timelineYearSlider,
	// 	},
	// });
}


// Playlists slider

if($('.playlist-row').length) {

	// breakpoint where swiper will be destroyed
	// and switches to a dual-column layout
	
	const breakpoint = window.matchMedia( '(min-width:768px)' );
	
	// keep track of swiper instances to destroy later
	let playlistsSwiper;
	
	const breakpointChecker = function() {
		// if larger viewport and multi-row layout needed
		if ( breakpoint.matches === true ) {
			
			// clean up old instances and inline styles when available
			if ( playlistsSwiper !== undefined ) playlistsSwiper.destroy( true, true );
			
			// or/and do nothing
			return;
			
			// else if a small viewport and single column layout needed
		} else if ( breakpoint.matches === false ) {
			
			// fire small viewport version of swiper
			return enableSwiper();
			
		}
		
	};
	
	const enableSwiper = function() {
		playlistsSwiper = new Swiper ('.playlist-row', {
			lazy: true,
			loop: false,
			slidesPerView: 1,
			spaceBetween: 24,
			grabCursor: true,
			breakpoints: {
				568: {
					slidesPerView: 2,
				},
			},
		});
		
	};
	
	
	// keep an eye on viewport size changes
	breakpoint.addListener(breakpointChecker);
	
	// kickstart
	breakpointChecker();
	
	// Slider check and lazy images load
	if(!$('.playlist-row').hasClass('swiper-initialized')) {
		$('.playlist-block > figure > img').each(function () {
			var $this = $(this),
				$thisSrc = $this.data('src');
			$this.next('.swiper-lazy-preloader').remove();
			$this.removeAttr('data-src');
			$this.attr('src', $thisSrc);
		})
	}

}
